import toast from 'react-hot-toast';
import axios from '../../config/axios';
import { RoleCreateData, RoleGetData } from './types';

const getAll = async (): Promise<RoleGetData[]> => {
  try {
    const { data } = await axios.get<RoleGetData[]>('/role');
    return data;
  } catch (error) {
    toast.error('Error getting roles');
    return [];
  }
};

const create = async (payload: RoleCreateData): Promise<boolean> => {
  try {
    await axios.post('/role/create', payload);
    toast.success('Role created successfully');
    return true;
  } catch (error: any) {
    const message = error?.response?.data?.message;
    toast.error(message || 'Failed to create role');
    return false;
  }
};

const update = async (id: string, payload: RoleCreateData): Promise<boolean> => {
  try {
    await axios.put(`/role/update/${id}`, payload);
    toast.success('Role updated successfully');
    return true;
  } catch (error: any) {
    const message = error?.response?.data?.message;
    toast.error(message || 'Failed to update role');
    return false;
  }
};

const remove = async (id: string): Promise<boolean> => {
  try {
    await axios.delete(`/role/delete/${id}`);
    toast.success('Role deleted successfully');
    return true;
  } catch (error: any) {
    const message = error?.response?.data?.message;
    toast.error(message || 'Failed to delete role');
    return false;
  }
};

export { getAll, create, update, remove };
